let TOOLS = TOOLS || {};

TOOLS.CAROUSEL = {

  init: function() {
    let self = this;

    self.initCarousel();
  },

  initCarousel: function() {
    let self = this;

    if ($('.js-carousel').length) {
      $('.js-carousel').each(function(i) {
        $('.js-carousel').attr('data-carousel-id', i);
        $('.js-carousel[data-carousel-id=' + i + ']').slick({
          slidesToShow: 4,
          prevArrow: '<div class="p-sell-support-service__arrow --prev"></div>',
          nextArrow: '<div class="p-sell-support-service__arrow --next"></div>',
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                centerMode: true,
              }
            }
          ]
        });
      });
    }
  }
}

$(function() {
  TOOLS.CAROUSEL.init();
});
